import {
  GetIsMutationSuccessfulPredicates,
  SubscriptionsToMutationsMap,
} from './subscriptionsMutationsMap.types'

export const getIsMutationSuccessfulPredicates: GetIsMutationSuccessfulPredicates = {
  shareDelete: data => !!data.shareDelete?.successful,
  shareRestore: data => !!data.shareRestore?.successful,
  deleteSharePermanently: () => true,
  emptyWorkspaceTrash: () => true,
}

export const subscriptionsToMutationsMap: SubscriptionsToMutationsMap = {
  shareDeleted: {
    name: 'shareDelete',
    getVariables: ({ shareDeleted }) => ({
      identifier: shareDeleted.share.identifier,
    }),
  },
  shareRestored: {
    name: 'shareRestore',
    getVariables: ({ shareRestored }) => ({
      identifier: shareRestored.share.identifier,
    }),
  },
  deletedSharePermanently: {
    name: 'deleteSharePermanently',
    getVariables: ({ deletedSharePermanently }) => ({
      shareIdentifier: deletedSharePermanently.shareIdentifier,
      workspaceId: deletedSharePermanently.workspaceIdentifier,
    }),
  },
  emptiedWorkspaceTrash: {
    name: 'emptyWorkspaceTrash',
    getVariables: ({ emptiedWorkspaceTrash }) => ({
      identifier: emptiedWorkspaceTrash.workspaceIdentifier,
    }),
  },
}
